import React, { useEffect, useState } from "react";
import { LoginInputs } from "../../../../Components/LoginInputs";
import { SignIn } from "../../../../Components/SignIn";
import { InputContainer, InputButton, HelperSpan } from "./styles";
import { SignInButton } from "../../../../Components/Buttons/SingnInButton";
import { RememberPassword } from "../../../../Components/RememberPassword";
import { useCartorio } from "../../../../Hooks/cartorio";
import { validateCPF } from "../../../../Services/validateCPF";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { cnpjMask } from "../../../../Services/cnpjMask";
import { cpfMask } from "../../../../Services/cpfMask";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { Alert } from "../../../../Components/Error/Alert";
import { cartorioKey } from "../../../../Utils/localStorageKeys";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { Span } from "../SignInCartorio/styles";
import { app_base_url } from "../../../../Utils/baseUrl";
import { useNavigate } from "react-router";


export function SignInPrefeitura() {

  const{signInPrefeitura} = usePrefeitura();

  const [nome, setNome] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { signInCartorio,cartorio } = useCartorio();

  function handleNome(n: string) {
    setNome(n);
   
  }

  function handleSenha(pass: string) {
    setSenha(pass.trim());
  }

  async function handleSignIn() {
    setLoading(true);

   

    try {
      

      
      if (senha.length == 0) {
        setError("O campo senha não pode ser vázio!");
        setErrorTitle("Senha inválida!");
        return;
      }
    await signInPrefeitura(nome,senha);
    } catch (error) {
      setError(
        `Sua combinação de nome
        e senha estão incorretos!  `
      );
      setErrorTitle("Dados de login inválidos!");
    } finally {
      setLoading(false);
    }
  }


  return (
    <SignIn
      children={
        <>
          <InputContainer>
            <LoginInputs
              placeholder="NOME"
              type="nome"
              execute={handleNome}
              value={nome}
            />
          </InputContainer>
          <InputContainer>
            <LoginInputs
              placeholder="SENHA"
              type="pass"
              execute={handleSenha}
              value={senha}
            />
          </InputContainer>

          <InputButton>
            <SignInButton
              text="LOGIN"
              enable={false}
              type={"login"}
              execute={handleSignIn}
              loading={loading}
            />
          </InputButton>
          <HelperSpan onClick={() => navigate(`${app_base_url}/prefeitura/funcionario`)}>
              <Span>Logar como funcionário</Span>
              
             </HelperSpan>

         
          <Alert
            message={error}
            onClose={() => {
              setError("");
            }}
            open={error.length > 0}
            title={errorTitle}
          />
        </>
      }
    />
  );
}
